var ru = {
  "Add Quantity Breaks to your product page": "Добавьте скидки за количество на страницу товара",
  "Add Upsell.com to your ": "Добавьте Upsell.com на вашу ",
  "Add to cart click": "Клик по «Добавить в корзину»",
  "All time": "Все время",
  "and select": "и выберите",
  "button": "кнопку",
  "Cart drawer page": "Страница выдвижной корзины",
  "Cart page": "Страница корзины",
  "Check status": "Проверить статус",
  "Checkout page": "Страница оформления заказа",
  "Checkout click": "Клик по «Оформление заказа»",
  "Click": "Нажмите",
  "Click on": "Нажмите на",
  "Click the": "Нажмите на",
  "Custom slot": "Пользовательский слот",
  "Custom slots": "Пользовательские слоты",
  "Custom Slots": "Пользовательские слоты",
  "Enable in theme editor": "Включить в редакторе темы",
  "contact support.": "свяжитесь со службой поддержки.",
  "from the right sidebar": "из правой боковой панели",
  "Go to App Embeds": "Перейти к встраиваниям приложений",
  "Go to your Cart drawer page": "Перейдите на страницу выдвижной корзины",
  "Go to your Cart page": "Перейдите на страницу корзины",
  "Go to your Checkout page": "Перейдите на страницу оформления заказа",
  "Go to your Order status page": "Перейдите на страницу статуса заказа",
  "Go to your Post purchase page": "Перейдите на страницу после покупки",
  "Go to your Product page": "Перейдите на страницу товара",
  "Go to your Thank you page": "Перейдите на страницу «Спасибо»",
  "items": "товары",
  "in the left sidebar": "в левой боковой панели",
  "Last 12 months": "Последние 12 месяцев",
  "Last 30 days": "Последние 30 дней",
  "Last 365 days": "Последние 365 дней",
  "Last 7 days": "Последние 7 дней",
  "Last 90 days": "Последние 90 дней",
  "Last month": "Прошлый месяц",
  "Last year": "Прошлый год",
  "Make sure": "Убедитесь, что",
  "Need assistance? Contact our support team for help.": "Нужна помощь? Свяжитесь с нашей службой поддержки.",
  "Order status page": "Страница статуса заказа",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "Наше приложение в настоящее время обновляется, чтобы улучшить ваш опыт.",
  "Post purchase page": "Страница после покупки",
  "Product page": "Страница товара",
  "Save": "Сохранить",
  "Scroll to the bottom and select": "Прокрутите вниз и выберите",
  "Select": "Выбрать",
  "Success. Please continue.": "Успешно. Пожалуйста, продолжайте.",
  "Thank you page": "Страница «Спасибо»",
  "The Upsell.com team.": "Команда Upsell.com.",
  "The Upsell.com widget is not placed on ": "Виджет Upsell.com не размещен на ",
  ". Please follow the steps above or ": ". Пожалуйста, следуйте инструкциям выше или ",
  "Today": "Сегодня",
  "toggle is on": "переключатель включен",
  "Total": "Итого",
  "under": "под",
  "We apologize for any inconvenience caused,": "Приносим извинения за доставленные неудобства,",
  "We apologize for any inconvenience caused.": "Приносим извинения за доставленные неудобства.",
  "We'll be done in a few minutes!": "Мы закончим через несколько минут!",
  "We're improving our services!": "Мы улучшаем наши услуги!",
  "Widget already added": "Виджет уже добавлен",
  "Yesterday": "Вчера",
  "You enabled the widget in your online store but didn't save it in the Upsell editor": "Вы включили виджет в интернет-магазине, но не сохранили его в редакторе Upsell",
  "You placed the widget on the ": "Вы разместили виджет на ",
  ", but you didn't save it in Shopify editor. Please go back to ": ", но не сохранили его в редакторе Shopify. Пожалуйста, вернитесь на ",
  " and save the changes.": " и сохраните изменения."
};

export { ru as default };
//# sourceMappingURL=ru.json.js.map
